export const STORES_SET = 'set_stores';
export const STORE_SET = 'set_store';
export const STORE_SET_SAVED = 'set_store_saved';
export const SYNC_FAILED = 'update_sync_error';
export const SYNC_FINISHED = 'stores_sync_has_finished';
export const SYNC_INITIATED = 'stores_sync_was_initiated';
